export default __webpack_public_path__ + "static/media/user.1f079707.svg";